import { ReduxStore } from 'store/types';

function getAllIsLoading(state: ReduxStore): boolean {
  return state.product.getAll.config.isLoading;
}

export default getAllIsLoading;
